import React, { createContext, useContext, useState, useCallback } from 'react';

interface HelpContextValue {
  helpOpen: boolean;
  openHelp: () => void;
  closeHelp: () => void;
}

const HelpContext = createContext<HelpContextValue>({
  helpOpen: false,
  openHelp: () => {},
  closeHelp: () => {},
});

export const HelpProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [helpOpen, setHelpOpen] = useState(false);
  const openHelp = useCallback(() => setHelpOpen(true), []);
  const closeHelp = useCallback(() => setHelpOpen(false), []);
  return (
    <HelpContext.Provider value={{ helpOpen, openHelp, closeHelp }}>
      {children}
    </HelpContext.Provider>
  );
};

export const useHelp = () => useContext(HelpContext);
